import { InjectionToken } from '@angular/core';
import { PAGE_PARAMS_DEFAULT_PAGE_SIZE } from '../page-params/default-page-size.const';
import { DefaultPageParams } from '../page-params';

export const DEFAULT_PAGE_PARAMS = new InjectionToken<DefaultPageParams>('defaultPageParams', {
  factory: () => ({ pageSize: PAGE_PARAMS_DEFAULT_PAGE_SIZE, pageNumber: 1 }),
});
